export enum Color {
  enosBlueLight = "#456D7B",
  enosBlue = "#296573",
  enosBlueDark = "#1D4E5F",
  enosRose = "#8D4F61",
  enosYellow = "#DA9914",
  text1 = "#1A1A1A",
  text2 = "#303030",
  text3 = "#666666",
  text4 = "#7E7E7E",
  text5 = "#98A2B3",
  lightGray = "#F5F5F5",
  white = "#FFFFFF",
  red = "red",
  green = "green",
}

export type ColorType = keyof typeof Color;
